import PageHeader from '../../layout/PageHeader'
import { MainContainer } from '../../components/Contents/Contents.element'
import { usePlayerSearch } from '../../contexts/SearchPlayersContext'
import PlayerSearchInit from '../../components/PlayerLanding/PlayerSearch/PlayerSearchInit'
import PlayerFilterResultsPage from '../../components/PlayerLanding/PlayerSearch/PlayerFilterResultsPage'
import { useLoading } from '../../contexts/LoadingContext'
import LoadingSpinner from '../../ui/LoadingSpinner'
import '../../pages/Clubs/clubsearch.css';
import { useCallback, useEffect } from 'react'
import { useNotification } from '../../contexts/NotificationContext'
import { useNavigate } from 'react-router-dom'
import { useSidebar } from '../../contexts/SidebarContext'
import ClubSearchResultPage from './ClubSearchResultPage'
import { useClubSearch } from '../../contexts/ClubSearchContext'

const ClubSearchComponent = () => {
    const { setTotalRevenue, setTotalCost, setTotalProfitLoss, setTotalDebt, setAssetsLiabilities, setDebtVsAssetsRatio,
        setTotalIntangibleAssets, setTotalReceivables, setReceivablesPercentage, setRegionValues, setClubCurrentPage, setIsFilterChange
        , setSortClubOrderName, setSortClubOrdering,setAvgSquadValue,setSquadPurchaseCostVSValue,setAvgSystemFit,setAvgPlayerAge
        ,setClubRegionValues
    } = useClubSearch();
    const navigate = useNavigate();
    const { hideNotification, setNotificationContent, setDisplayNotification } = useNotification();
    const { loading } = useLoading();

    const handleClearClubList = useCallback(() => {
        setTotalRevenue({ min: 0, max: 2000000000 });
        setTotalCost({ min: 0, max: 2000000000 });
        setTotalProfitLoss({ min: -500000000, max: 1000000000 });
        setTotalDebt({ min: 0, max: 3000000000 });
        setAssetsLiabilities({ min: 0, max: 10 });
        setDebtVsAssetsRatio({ min: 0, max: 40 });
        setTotalIntangibleAssets({ min: 0, max: 1000000000 });
        setTotalReceivables({ min: 0, max: 1000000000 });
        setReceivablesPercentage({ min: 0, max: 500 });
        setAvgSquadValue({ min: 0, max: 180000000 });
        setSquadPurchaseCostVSValue({ min: 0, max: 180000000 });
        setAvgSystemFit({ min: 0, max: 100 });
        setAvgPlayerAge({ min: 16, max: 55 });
        setClubRegionValues([]);
        setClubCurrentPage(1);
        setIsFilterChange(false);
        setSortClubOrderName('Revenue');
        setSortClubOrdering('DESC');
        hideNotification();
        setNotificationContent(null);
        setDisplayNotification(false);
    }, [
        setTotalRevenue,
        setTotalCost,
        setTotalProfitLoss,
        setTotalDebt,
        setAssetsLiabilities,
        setDebtVsAssetsRatio,
        setTotalIntangibleAssets,
        setTotalReceivables,
        setReceivablesPercentage,
        setRegionValues,
        setClubCurrentPage,
        setIsFilterChange,
        setSortClubOrderName,
        setSortClubOrdering,
        hideNotification,
        setNotificationContent,
        setDisplayNotification
    ]);

    // useEffect(() => {
    //     handleClearClubList();
    // }, [])

    return (
        <MainContainer className={'main-container player-detail-page'}>
            <PageHeader title='Clubs' clearClubList onClearClubListClick={() => {
                handleClearClubList();
                navigate("/clubsearch")
            }} clubResultList />

            <div className="player-tab-content player-filter-result">
                <ClubSearchResultPage onClearClubListClick={() => {
                    handleClearClubList();
                    navigate("/clubsearch")
                }} />
            </div>

            {loading && <LoadingSpinner />}
        </MainContainer>
    )
}

export default ClubSearchComponent;
